module.exports = __webpack_public_path__ + "files/8aa8483f562c63dcfe411df064199064.png";